import React from "react";
import { VehicleCashHistory } from "@/components/VehicleCashHistory";

export default function VehicleCashHistoryPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>Riwayat Potongan Kas Kendaraan</h2>
        <p className="text-sm text-muted-foreground">Pengeluaran kendaraan yang memotong setiap pencairan kas Tim Kendaraan</p>
      </div>
      <VehicleCashHistory showName />
    </div>
  );
}
